// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import ContactModalController from "./contact_modal_controller"
application.register("contact-modal", ContactModalController)

import RichTextController from "./rich_text_controller"
application.register("rich-text", RichTextController)

import CoverPreviewController from "./cover_preview_controller"
application.register("cover-preview", CoverPreviewController)

import ImagePreviewsController from "./image_previews_controller"
application.register("image-previews", ImagePreviewsController)

import ServiceSearchController from "./service_search_controller"
application.register("service-search", ServiceSearchController)

import CatalogToggleController from "./catalog_toggle_controller"
application.register("catalog-toggle", CatalogToggleController)

import PhotoViewerController from "./photo_viewer_controller"
application.register("photo-viewer", PhotoViewerController)

import PhotoManagerController from "./photo_manager_controller"
application.register("photo-manager", PhotoManagerController)

import SeoCounterController from "./seo_counter_controller"
application.register("seo-counter", SeoCounterController)

import PhotoLibraryController from "./photo_library_controller"
application.register("photo-library", PhotoLibraryController)

import RuPhoneController from "./ru_phone_controller"
application.register("ru-phone", RuPhoneController)

import CallbackRequestController from "./callback_request_controller"
application.register("callback-request", CallbackRequestController)

import OrderServicesController from "./order_services_controller"
application.register("order-services", OrderServicesController)

import CustomerSearchController from "./customer_search_controller"
application.register("customer-search", CustomerSearchController)
import ServicePriceController from "./service_price_controller"
application.register("service-price", ServicePriceController)
import OrderServiceSearchController from "./order_service_search_controller"
application.register("order-service-search", OrderServiceSearchController)
import CallbackStatusController from "./callback_status_controller"
application.register("callback-status", CallbackStatusController)
import CookieNoticeController from "./cookie_notice_controller"
application.register("cookie-notice", CookieNoticeController)
import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)
